import React from 'react';
import './timetable.scss';

import CustomerStatus from './customerStatus.js';
import CustomerDue from './customerDue.js';

import SupplierStatus from './supplierStatus.js';
import SupplierDue from './supplierDue.js';



import { TabPanel, Item as TabPanelItem} from 'devextreme-react/tab-panel';
import { useState,  useCallback} from "react";


//var dueDataGridRef = React.createRef();

export default function TimeTable() {


  const [selectedIndex, setSelectedIndex] = useState(0);

  // const addButtonOptions = {
  //   icon: 'plus',
  //   hint: 'Nuovo Movimento'
  //   // onClick: () => {
  //   //   notify('Add button has been clicked!');
  //   // },
  // };

  

  

  const onTabSelectionChanged = useCallback((args) => {
    if (args.name === 'selectedIndex') {
      setSelectedIndex(args.value);
    }
  }, [setSelectedIndex]);


  function renderSupplierStatusTab() {
    return <SupplierStatus/>;
  };

  function renderSupplierDueTab() {
    return <SupplierDue/>;
  };

  function renderCustomerStatusTab() {
    return <CustomerStatus/>;
  };

  function renderCustomerDueTab() {
    return <CustomerDue/>;
  };


  return (
  <React.Fragment>
    <h2 className={'content-block'}>Movimenti</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
       
      <TabPanel    
        onOptionChanged={onTabSelectionChanged}
      >
        <TabPanelItem title="Consegne Fornitori" render={renderSupplierStatusTab} />
        <TabPanelItem title="Pagamenti" render={renderSupplierDueTab} />
        <TabPanelItem title="Consegne Clienti" render={renderCustomerStatusTab} />
        <TabPanelItem title="Incassi" render={renderCustomerDueTab} />
      </TabPanel>
       
      </div>
    </div>
  </React.Fragment>
)
};
